export default "__VITE_ASSET__B52N5YK0__"